import axiosModules from "../axiosSetting";

export default {
  getRolePermission: () => axiosModules.get("/pauth/rolepermission/serviceId/siemweb"),
  getLicensePermission: () => axiosModules.get("/pauth/accessuser/licenseacitivys"),
  getUserLicense: () => axiosModules.get("/pauth/userlicensesummery"),
  getUseLicenseInfo: () => axiosModules.get("/pauth/userlicenseinfo")
};
